<template>
  <div data-cy="dadosEContato-container">
    <b-row data-cy="dadosEContato-row-cpf-email">
      <b-col lg="4" md="6" sm="12" class="mt-1" data-cy="dadosEContato-col-cpf">
        <label for="cpf" v-required data-cy="dadosEContato-label-cpf">
          CPF
        </label>
        <b-form-input
          :state="validation.cpf"
          class="form-control"
          type="text"
          id="cpf"
          v-mask="['###.###.###-##']"
          ref="numerodocumento"
          v-model="form.cpf"
          placeholder="CPF"
          required
          data-cy="dadosEContato-input-cpf"
        />
      </b-col>

      <b-col
        lg="8"
        md="6"
        sm="12"
        class="mt-1"
        data-cy="dadosEContato-col-email"
      >
        <label for="email" v-required data-cy="dadosEContato-label-email">
          E-mail
        </label>
        <b-form-input
          class="form-control"
          type="email"
          ref="email"
          :state="validation.email"
          v-model="form.email"
          id="email"
          required
          placeholder="E-mail"
          data-cy="dadosEContato-input-email"
        />
      </b-col>
    </b-row>

    <b-row data-cy="dadosEContato-row-telefone">
      <b-col
        lg="4"
        md="5"
        sm="12"
        class="mt-1"
        data-cy="dadosEContato-col-telefone"
      >
        <label for="telefone" v-required data-cy="dadosEContato-label-telefone">
          Telefone
        </label>
        <b-form-input
          class="form-control"
          type="tel"
          ref="telefoneprincipal"
          v-model="form.telefonePrincipal"
          :state="validation.telefonePrincipal"
          id="telefone"
          v-mask="[`(##) ####-####`, `(##) #####-####`]"
          placeholder="Telefone"
          required
          data-cy="dadosEContato-input-telefone"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "dadosEContato",
  props: ["form", "validation"],
  directives: { mask }
};
</script>

<style scoped></style>
